import PropTypes from "prop-types";

export const shortShape = {
  ref: PropTypes.string,
  name: PropTypes.string
};
